export const AVATAR_BASE_PATH = '/avatars';

export const AVATAR_LIST = [
  'bear', 'buffalo', 'chick', 'chicken', 'cow', 'crocodile', 'dog', 'duck',
  'elephant', 'frog', 'giraffe', 'goat', 'gorilla', 'hippo', 'horse',
  'monkey', 'moose', 'narwhal', 'owl', 'panda', 'parrot', 'penguin',
  'pig', 'rabbit', 'rhino', 'sloth', 'snake', 'walrus', 'whale', 'zebra'
].map(animal => ({
  id: animal,
  name: animal.charAt(0).toUpperCase() + animal.slice(1),
  url: `${AVATAR_BASE_PATH}/${animal}.png`
}));

export const DEFAULT_AVATAR = `${AVATAR_BASE_PATH}/bear.png`;
